import * as generalHealthHistory from './general-health-history.reducers';
import * as symptomsHistory from './symptoms-history.reducers';
import * as submissions from './user-submissions.reducers';
import * as weightHistory from './weight-history.reducers';
import * as basicWebkHistory from './basic-webk-history.reducers';
import * as userMetrics from './user-metrics.reducer';

export interface UserDataRootState {
  generalHealthHistory: generalHealthHistory.GeneralHealthHistoryState;
  symptomsHistory: symptomsHistory.SymptomsHistoryState;
  weightHistory: weightHistory.WeightHistoryState;
  basicWebkHistory: basicWebkHistory.BasicWebkHistoryState;
  submissionsState: submissions.UserSubmissionState;
  userMetrics: userMetrics.UserMetricsState;
}

export const userDataReducers = {
  generalHealthHistory: generalHealthHistory.generalHealthHistoryReducer,
  symptomsHistory: symptomsHistory.symptomHistoryReducer,
  weightHistory: weightHistory.weightHistoryReducer,
  basicWebkHistory: basicWebkHistory.basicWebkHistoryReducer,
  submissionsState: submissions.userSubmissionsReducer,
  userMetrics: userMetrics.userMetricsReducer,
};
